<template>
    <svg :width="width" :height="height" viewBox="0 0 8 8" fill="none" :class="design" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.18989 4L7.88294 1.30704C8.03869 1.15129 8.03869 0.898548 7.88294 0.742551L7.25718 0.116811C7.10142 -0.0389369 6.84867 -0.0389369 6.69267 0.116811L3.99987 2.81002L1.30683 0.117061C1.15108 -0.0386869 0.898327 -0.0386869 0.742324 0.117061L0.116814 0.742551C-0.0389381 0.898299 -0.0389381 1.15104 0.116814 1.30704L2.80986 4L0.116814 6.69296C-0.0389381 6.84871 -0.0389381 7.10145 0.116814 7.25745L0.742574 7.88319C0.898327 8.03894 1.15108 8.03894 1.30708 7.88319L3.99987 5.18998L6.69292 7.88294C6.84867 8.03869 7.10142 8.03869 7.25743 7.88294L7.88319 7.2572C8.03894 7.10145 8.03894 6.84871 7.88319 6.69271L5.18989 4Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    name: 'ui-x-mark-icon',
    props: {
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 8
        },
        height: {
            type: [String, Number],
            default: 8
        },
        fill: {
            type: String,
            default: '#fff'
        }
    }
}
</script>